// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__Q5u24","options":"AnswerScale_options__1653e","selected":"AnswerScale_selected__1b4iS"};